import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";

export const siteRoutes = {
  // Back home button, errorfallback etc
  home: "/home",
  landing: "/landing",
  default: brand.defaultNavigateUrl,
  // Auth
  login: "/login",
  signUp: "/signup",
  signUpSuccess: "/signup-success",
  signUp1: "/sign-up-1",
  quickAccount: "/create-quick-account",
  accountSetup: "/account-setup",

  // Profile
  profile: "/profile",
  profileAndSlug: "/profile/",
  profileSettings: "/profile-settings",
  profileTabAndSlug: "/profile-tab/",
  profileCommunityAndSlug: "/profile-community/",

  //  News
  news: "/news",
  newsAndSlug: "/news/",
  createNews: "/create-news",
  manageNews: "/news/manage/",

  // Feed posts
  dashboard: "/dashboard",
  singlePostAndSlug: "/post/",

  // Challenges
  challenges: "/challenges",
  challengesAndSlug: "/challenges/",
  createChallenge: "/create-challenge",
  submitScoreAndSlug: "/submit-score/",

  // Submissions
  submissions: "/submissions",

  // Challenges test
  newchallenges: "/challenges-alt",
  newchallenge: "/challenge-alt/",

  // Teams
  teams: "/teams",
  teamsAndSlug: "/teams/",
  createTeam: "/create-team",
  teamsMembersAndSlug: "/teams-members/",

  // Qr Sign up
  eventQrCode: "/event-qr-code",
  scanQrCodeAndSlug: "/scan-qr/",

  // Notifications
  notifications: "/notifications",

  // Zones
  zone: "/zone/",
  zones: "/zones",

  // Other | unused
  help: "/help",
  about: "/about",
  tracker: "/tracker",
  terms: "/terms",
  "privacy-policy": "/privacy-policy",
  friends: "/friends",
  search: "/search",
  winners: "/winners",
  schedule: "/schedule",

  partners: "/partners",
  partnersAndSlug: "/partners/",
  tcl: "/partners/tcl",
  tcl_popup: "/partners/tclpopup",
  logitech: "/partners/logitech",
  pcspecialist: "/partners/pcspecialist",
  jbl: "/partners/jbl",
  racing: "/partners/racing",
  cs2: "/partners/cs2",
  leet: "/1337-challenge",
  "leet-lg": "/1337-challenge-lg",
  "leet-vertical": "/1337-challenge-vertical",
  "leet-redirect": "/1337-redirect",
  "leet-reset-trigger": "/1337-challenge-reset-trigger",
  dailytasks: "dailytasks",
  spacecoins_redirect: "/space-coins-redirect",
  multiplayerBrowserGame_redirect: "/join-multiplayer-game",
  treasureHunt: "/treasure-hunt/",
  treasureHuntRedirect: "/treasure-hunt-redirect/",
  tcl_logs: "/partners/tcl/logs",
  gchallenge: "/g-challenge/",
  contactForm1337: "/1337-winner-contact-form",
  // activity
  activityAndSlug: "/activity/",

  // DBG
  leaderboard: "/leaderboard",
  gamepass: "/game-pass",
  gametracker: "/game-tracker",
  feedback: "/feedback",

  // Direct to challenge
  fallguys: "/fallguys",
  forzamotorsport: "/forzamotorsport",
  counterstrike: "/counterstrike",
  f1: "/f1",

  // Events
  events: "/events",
  eventAndSlug: "/event/",

  // Raffle
  raffle: "/raffle",
  TCLRaffle: "/tcl-raffle",

  // Gamebox Festival 2025
  PSRaffle: "/vind-en-ps",
  PSRedirect: "/ps-konkurrence",
  TimeTrial: "/tcl-time-trial",
  analytics: "/analytics",
};
